// @ts-nocheck
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import useBuyingList from "@store/Framework/Common/Hooks/useBuyingList/useBuyingList";
import useBuyingListState from "@store/Framework/Store/Bunzl/Pages/Reporting/StoreHooks/useBuyingListState";

import { useEffect, useRef } from "react";

const useFetchWhenUpdateBuyingListParams = () => {
    const { setApiParams } = useBuyingListState();
    const { buyingLists, loading, setLoading, getBuyingLists } = useBuyingList();
    const apiParams = useAppSelector(state => state.bunzl.pages.buyingList.apiParams);
    const hasloaded = useRef(false);

    useEffect(() => {
        if (!hasloaded.current) {
            hasloaded.current = true;
            return;
        }

        if (!buyingLists) {
            return;
        }

        const fetchBuyingListsWithNewParams = async () => {
            if (!loading) {
                setLoading(true);
            }
            await getBuyingLists(true);
            setLoading(false);
        };
        fetchBuyingListsWithNewParams();
    }, [apiParams.query, apiParams.page, apiParams.pageSize, apiParams.sort]);
    return apiParams;
};

export default useFetchWhenUpdateBuyingListParams;
